import { Lookup } from "@data-types";
import { OccupationDataType } from "@data-types/membership/registration";
import { httpClient, retryRequest } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformOccupationsApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/occupations`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findOccupations(): Promise<Lookup<OccupationDataType>> {
		const response = await retryRequest(() =>
			httpClient.get(
				`${this.baseUrl}?rpp=1000&translate=true`,
				this.getRequestHeaders()
			)
		);

		return response;
	}
}

export default PlatformOccupationsApiService;
